import { CommonTooltips } from "@mcleod/common";
import { ClickEvent, Component, Label, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { LogManager, ModelRow, Navigation } from "@mcleod/core";
import { AutogenLayoutMobileCommUnitList } from "./autogen/AutogenLayoutMobileCommUnitList";
import { ActionButtonType, MobileCommUnitToolPanel } from "./MobileCommUnitToolPanel";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommUnitList");

export class MobileCommUnitList extends AutogenLayoutMobileCommUnitList {
    public _toolsPanel: MobileCommUnitToolPanel;
    public isFindNearData: boolean = false;
    searchList: () => void;
    removeCircle: () => void;

    onLoad(): void | Promise<void> {
        this._toolsPanel = new MobileCommUnitToolPanel(this, ActionButtonType.CHANGE, ActionButtonType.FILTERS,
            ActionButtonType.GROUP, ActionButtonType.REEFER_SETTINGS);
    }

    tableMCUnitOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxMCUnitType = tableRow.findComponentById("textboxMCUnitType") as Textbox;
        textboxMCUnitType.allowTooltip = false;

        const labelTrailerReferId = tableRow.findComponentById("labelTrailerReeferId") as Label;
        labelTrailerReferId.applyLinkStyle();
    }

    setTooltipContent(comp: Component, modelRow: ModelRow) {
            CommonTooltips.setTooltipContentLayout(comp, modelRow.get("trailer.reefer_id"), "lme/dispatch/asset/ReeferQuickInfo", { minWidth: 128, minHeight: 140 });
    }

    reeferIdOnClick(event: ClickEvent) {
        if ((event.target as Label).text) {
            Navigation.navigateTo("lme/dispatch/mobilecomm/MobileCommReefer?mode=update&key=" + (event.target as Label).text, {newTab: true});
        }
    }
}
